import { Component } from "react";
import JSONTree from "react-json-tree";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import Button from "@material-ui/core/Button";

import _ from "underscore";
import PropTypes from "prop-types";
import { accountingConnector } from "../../../services/accounting/connector";
import { compose } from "redux";

class AccountingExportComponent extends Component {
  constructor(props) {
    super(props);

    let columns = [
      {
        key: "VoucherSeries",
        label: "Voucher series",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Comments",
        label: "Comments",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "TransactionDate",
        label: "Transaction date",
        visible: true,
        type: CELL_TYPES.text,
      },

      {
        key: "Account",
        label: "Account",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "CostCenter",
        label: "Cost center",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "Credit", label: "Credit", visible: true, type: CELL_TYPES.text },

      { key: "Debit", label: "Debit", visible: true, type: CELL_TYPES.money },
      {
        key: "Description",
        label: "Description",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Project",
        label: "Project",
        visible: true,
        type: CELL_TYPES.text,
      },

      {
        key: "TransactionInformation",
        label: "Transaction information",
        visible: true,
        type: CELL_TYPES.text,
      },
    ];

    this.state = { columns };
  }

  UNSAFE_componentWillMount() {
    this.props.getAccountingEurope();
    this.props.getAccountingSweden();
  }

  renderSummary(data) {
    var byAccount = _.groupBy(data, (row) => row.Account);
    return (
      <table className="table table-condensed table-striped">
        <thead>
          <tr>
            <th>Account</th>
            <th className="text-right">Debit</th>
            <th className="text-right">Credit</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(byAccount).map((key) => {
            return (
              <tr key={key}>
                <td>{key}</td>
                <td className="text-right">
                  {byAccount[key]
                    .reduce((t, o) => {
                      return t + parseFloat(o.Debit);
                    }, 0)
                    .toFixed(2)}
                </td>
                <td className="text-right">
                  {byAccount[key]
                    .reduce((t, o) => {
                      return t + parseFloat(o.Credit);
                    }, 0)
                    .toFixed(2)}
                </td>
              </tr>
            );
          })}
          <tr>
            <td>Total</td>
            <td className="text-right">
              {data
                .reduce((t, o) => {
                  return t + parseFloat(o.Debit);
                }, 0)
                .toFixed(2)}
            </td>
            <td className="text-right">
              {data
                .reduce((t, o) => {
                  return t + parseFloat(o.Credit);
                }, 0)
                .toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderTable(state) {
    if (!state.data || !state.table) {
      return <div>Loading...</div>;
    }

    return (
      <TableNew
        columns={this.state.columns}
        items={state.data}
        tableKey="AccountingExport"
      />
    );
  }

  renderAccountingView(state, refresh, exp) {
    return (
      <div>
        {state.error ? (
          <div style={{ "white-space": "pre-wrap", "word-wrap": "break-word" }}>
            {state.error}
          </div>
        ) : null}
        {state.fetching ? <div>Fetching...</div> : null}
        {state.exporting ? <div>Exporting...</div> : null}
        {state.data ? <div>{this.renderSummary(state.data)}</div> : null}
        {state.data ? (
          <div>
            {new Set(state.data.map((row) => row.EventGlobalSeqNr)).size}{" "}
            vouchers
          </div>
        ) : null}
        <div className="panel-body">
          <Button variant="contained" color="primary" onClick={refresh}>
            Refresh
          </Button>{" "}
          &nbsp;
          <Button variant="contained" color="primary" onClick={exp}>
            Export
          </Button>
        </div>
      </div>
    );
  }

  render() {
    let sweState = this.props.accounting.accountingSweden;
    let eurState = this.props.accounting.accountingEurope;
    return (
      <div>
        <div className="accounting-layout body-height content-padding row">
          <div className="col-md-6 text-center">
            <h2>Europe</h2>
            {this.renderAccountingView(
              eurState,
              () => this.props.getAccountingEurope(),
              () => this.props.exportAccountingEurope(),
            )}
          </div>
          <div className="col-md-6 text-center">
            <h2>Sweden</h2>
            {this.renderAccountingView(
              sweState,
              () => this.props.getAccountingSweden(),
              () => this.props.exportAccountingSweden(),
            )}
          </div>
        </div>
        <div>
          <div className="col-sm-12">
            <h2>Europe</h2>
            {this.renderTable(
              eurState,
              this.props.changeAccountingListPageEurope,
              this.props.changeAccountingListFilterEurope,
            )}
            <JSONTree data={eurState.rawData} />
          </div>
        </div>
        <div>
          <div className="col-sm-12">
            <h2>Sweden</h2>
            {this.renderTable(
              sweState,
              this.props.changeAccountingListPageSweden,
              this.props.changeAccountingListFilterSweden,
            )}
            <JSONTree data={sweState.rawData} />
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    getAccountingEurope: PropTypes.func,
    getAccountingSweden: PropTypes.func,
    changeAccountingListPageEurope: PropTypes.func,
    changeAccountingListPageSweden: PropTypes.func,
    changeAccountingListFilterEurope: PropTypes.func,
    changeAccountingListFilterSweden: PropTypes.func,
    exportAccountingEurope: PropTypes.func,
    exportAccountingSweden: PropTypes.func,
    accounting: PropTypes.object,
  };
}
export default compose(accountingConnector)(AccountingExportComponent);
